import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions } from 'redux-actions';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './investmentQuotesV2Actions';

const investmentQuotesV2Reducer = handleActions({

  [actions.getInvestmentQuotesV2]:
    (state) => state.merge({ isLoading: true }),
  [actions.getInvestmentQuotesV2Success]:
    (state, action) => upsertResources(state, action.payload),
  [actions.getInvestmentQuotesV2Failure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const INVESTMENT_QUOTES_V2_REDUCER_KEY = 'investmentQuotesV2Store';
export default investmentQuotesV2Reducer;
